@if (show) {
  <div data-cy="consult-create-efektika-strategy" class="efektika-modal-content">
    <div>
      <p>{{ 'modal.efektikaConsultant.text1' | translate }}</p>
      <ul class="efektika-list">
        <li><span class="roman-bullet">(i)</span>{{ 'modal.efektikaConsultant.list.item1' | translate }}</li>
        <li><span class="roman-bullet">(ii)</span>{{ 'modal.efektikaConsultant.list.item2' | translate }}</li>
        <li><span class="roman-bullet">(iii)</span>{{ 'modal.efektikaConsultant.list.item3' | translate }}</li>
        <li><span class="roman-bullet">(iv)</span>{{ 'modal.efektikaConsultant.list.item4' | translate }}</li>
        <li><span class="roman-bullet">(v)</span>
          <div class="link-wrapper">
            {{ 'modal.efektikaConsultant.list.item5' | translate }}
            <div class="document-link"
              (click)="efektikaPdfDownloadService.downloadEfektikaPdf()"
              (keydown.space)="efektikaPdfDownloadService.downloadEfektikaPdf()"
              (keydown.enter)="efektikaPdfDownloadService.downloadEfektikaPdf()"
              tabindex="0"
            >
              {{ 'modal.efektikaItemLink' | translate }}
            </div>
          </div>
        </li>
      </ul>
      <p>{{ 'modal.efektikaConsultant.text2' | translate }}</p>
    </div>
    <div class="action-buttons-container">
      <libero-button
        label="{{ 'global.buttons.createEfektikaStrategy' | translate }}"
        btnClasses="btn--primary btn--heading btn--s-20"
        (click)="onContinueBtnClick()"
        data-cy="consult-create-efektika-strategy-continue-btn"
      ></libero-button>
      <libero-button
        label="{{ 'global.buttons.back' | translate }}"
        btnClasses="btn--secondary"
        (click)="onBackBtnClick()"
      ></libero-button>
    </div>
  </div>
}
